export enum ResendIntervalType {
    Minutes,
    Hours
}

export enum AlertPreferenceType {
    DistanceMeasurement = 1,
    VolumeMeasurement = 2,
    TemperatureMeasurement = 3,
    Currency = 4,
    Language = 5,
    Timezone = 6
}
